export type GeoPricingTextTokens = {
  percentageDiscount?: number;
  countryName?: string;
  boldHtml?: boolean;
};

const formatPercentageDiscount = (percentageDiscount?: number) =>
  percentageDiscount != null ? `${percentageDiscount}%` : "";

const formatLocation = (countryName: string | undefined, boldHtml?: boolean) =>
  boldHtml ? `<b>${countryName ?? ""}</b>` : (countryName ?? "");

/** Replaces Monarch geo-pricing placeholders `[x%]` and `[location]` in copy. */
export const resolvedGeoPricingText = (
  text: string | undefined,
  { percentageDiscount, countryName, boldHtml }: GeoPricingTextTokens,
): string | undefined => {
  if (!text) {
    return text;
  }

  return text
    .replace(/\[x%\]/gi, formatPercentageDiscount(percentageDiscount))
    .replace(/\[location\]/gi, formatLocation(countryName, boldHtml));
};
